module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/appModalView.html -->\n<div class="modal-dialog modal-md">\n	<div class="modal-content">\n		<div class="modal-header">\n			<div data-nx-control="crumbs"></div>\n			<button \n				class="close va" \n				data-nx-control="close"\n				title="'+
((__t=( i18n.t('i18n.close') ))==null?'':__t)+
'"\n			>\n				'+
((__t=( icons.faTimes ))==null?'':__t)+
'\n			</button>\n		</div>\n		<div class="modal-body">\n			<div data-nx-control="modal-content"></div>\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
